export const VARIANTS_LIMIT = 2000;
